import "./LinearLoadingBar.css";

const LinearLoadingBar = ({ className = "" }) => (
  <div
    className={`linear-loading-bar${className ? ` ${className}` : ""}`}
    role="progressbar"
    aria-label="Loading"
    aria-busy="true"
  >
    <div className="linear-loading-bar__indicator" />
  </div>
);

export default LinearLoadingBar;
